<template>
  <ion-page>
    <Header title="Kết quả"></Header>
    <ion-content>
      <ion-list>
        <ion-item @click="router.push('/results/keno')" button>Keno</ion-item>
        <ion-item @click="router.push('/results/power')" button
          >Power 6/55</ion-item
        >
        <ion-item @click="router.push('/results/mega')" button
          >Mega 6/45</ion-item
        >
        <ion-item @click="router.push('/results/max3d')" button
          >Max 3D</ion-item
        >
        <ion-item @click="router.push('/results/max3dpro')" button
          >Max 3D PRO</ion-item
        >
        <!-- <ion-item @click="router.push('/results/max4d')" button>Max 4D</ion-item> -->
        <!-- <ion-item @click="router.push('/results/xskt')" v-if="false">Xổ số kiến thiết</ion-item> -->
      </ion-list>
    </ion-content>
    <ion-button
      class="scan-button"
      fill="outline"
      expand="block"
      @click="openScanner"
      v-if="!isPlatform('desktop') && !isPlatform('mobileweb')"
    >
      Quét mã dò vé
      <ion-icon slot="end" :src="qrCodeOutline"></ion-icon>
    </ion-button>
    <ion-footer>
      <TabBar select="results"></TabBar>
    </ion-footer>
  </ion-page>
</template>

<style scoped>
ion-button.scan-button {
  margin-left: 2vw;
  margin-right: 2vw;
}
</style>

<script>
import Header from "@/components/Header.vue";
import {
  IonPage,
  IonContent,
  IonItem,
  IonList,
  IonFooter,
  IonButton,
  IonIcon,
  isPlatform,
} from "@ionic/vue";
import { defineComponent, computed } from "vue";
import { useRouter } from "vue-router";
import TabBar from "@/components/TabBar.vue";
import { qrCodeOutline } from "ionicons/icons";
import authService from "@/services/auth";
import * as utils from "@/utils";

export default defineComponent({
  name: "MenuTab",
  components: {
    IonContent,
    IonPage,
    IonItem,
    IonList,
    Header,
    IonFooter,
    TabBar,
    IonButton,
    IonIcon,
  },
  setup() {
    const router = useRouter();
    const isLoggedIn = computed(() => {
      return authService.user() && !authService.user().isAnonymous;
    });

    return {
      router,
      qrCodeOutline,
      isPlatform,

      async openScanner() {
        // if (isLoggedIn.value) {
          await router.push("/info/scanticket");
        // } else {
          // await utils.alert("Chức năng chỉ dành cho thành viên");
        // }
      },
    };
  },
});
</script>
